export const canShowPlayerJoinAction = ({
  isActiveRun,
  isPrimaryHost,
  isJoined,
  isAgeIneligible,
}) => (
  Boolean(isActiveRun)
  && !isPrimaryHost
  && !isJoined
  && !isAgeIneligible
);

export const isPrimaryHostJoinIneligible = (eligibility) => (
  eligibility?.can_join === false
  && eligibility?.reason_code === 'primary_host'
);
